<template>
<b-row>
    <b-col cols="12" md="auto">
        <b-nav vertical class="OTurlSubMenu">
            <b-nav-item :to="routes[0]" active-class="active">
                Seed URLs ({{totalSeedUrls}})
            </b-nav-item>
            <b-nav-item :to="routes[1]" active-class="active">
                Crawling Filters ({{totalCrawlingFilters}})
            </b-nav-item>
            <b-nav-item :to="routes[2]" active-class="active">
                Ingestion Filters ({{totalIngestionFilters}})
            </b-nav-item>
        </b-nav>
    </b-col>
    <b-col>
        <router-view :job="job"></router-view>
    </b-col>
</b-row>
</template>

<script>

export default {

    props: ['job'],

    computed: {
        routes() {
            return [{
                name: 'seed-urls',
                params: {
                    job_id: this.job.id
                }
            },{
                name: 'crawling-filters',
                params: {
                    job_id: this.job.id
                }
            },{
                name: 'ingestion-filters',
                params: {
                    job_id: this.job.id
                }
            }]
        },

        totalSeedUrls() {
            return this.$lodash.get(this.job.attributes, 'job_criteria.urls', []).length;
        },

        totalCrawlingFilters() {
            return this.getTrueFiltersLength(this.$lodash.get(this.job.attributes, 'job_criteria.url_filters', []));
        },

        totalIngestionFilters() {
            return this.getTrueFiltersLength(this.$lodash.get(this.job.attributes, 'job_criteria.ingestion_filters', []));
        }
    },

    methods: {
        getTrueFiltersLength(filters) {
            // Filter lists include a last item where the expression is '.'
            // This denotes whether everything else should be allowed or not, but it is not
            // a user-submitted filter.
            if (filters.length === 0) return 0;
            if (filters[filters.length-1].expression === '.') {
                return filters.length-1;
            } else {
                return filters.length;
            }
        }
    },

    mounted() {
        var breadcrumbs = [{
            name: 'jobs',
            meta: { label: 'Jobs' }
        },{
            name: 'job-edit',
            meta: { label: this.job.get('job_name') },
            params: { job_id: this.job.id }
        },{
            name: 'url-management',
            meta: { label: 'URL Management' },
            params: { job_id: this.job.id }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    }

}

</script>
